export default __webpack_public_path__ + "static/4-d25f6aed681efde58e9aee8b2a45f856.jpeg";